import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Send, MessageCircle } from 'lucide-react';
export function Contact() {
  return <footer id="contact" className="bg-white pt-12 pb-12 border-t border-slate-100" data-id="element-26">
      <div className="max-w-7xl mx-auto px-6" data-id="element-27">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20" data-id="element-28">
          <div data-id="element-29">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl font-bold mb-6 tracking-tight text-slate-900" data-id="element-30">
              Довірте захист <br data-id="element-31" />
              <span className="text-slate-400" data-id="element-32">професіоналам.</span>
            </motion.h2>
            <p className="text-slate-500 text-lg mb-10 max-w-md" data-id="element-33">
              Перша консультація до 5 хвилин — безкоштовна. Зателефонуйте нам, і
              ми знайдемо законне рішення вашої проблеми.
            </p>

            <a href="tel:+380687870587" className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-slate-900 hover:bg-slate-800 text-white rounded-full transition-all duration-300 text-sm font-semibold shadow-sm" data-id="element-34">
              <Phone className="w-4 h-4" data-id="element-35" />
              068 787 0587
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10" data-id="element-36">
            <div className="space-y-8" data-id="element-37">
              <div data-id="element-38">
                <h4 className="text-xs font-bold uppercase tracking-widest text-slate-400 mb-4" data-id="element-39">
                  Месенджери
                </h4>
                <div className="flex flex-col gap-3" data-id="element-40">
                  <a href="https://t.me/+380687870587" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-5 py-3 rounded-2xl border border-slate-100 hover:border-slate-200 hover:bg-slate-50 text-slate-700 transition-all font-medium text-sm" data-id="element-41">
                    <Send className="w-4 h-4 text-blue-500" data-id="element-42" />
                    Telegram
                  </a>
                  <a href="viber://chat?number=%2B380687870587" className="inline-flex items-center gap-3 px-5 py-3 rounded-2xl border border-slate-100 hover:border-slate-200 hover:bg-slate-50 text-slate-700 transition-all font-medium text-sm" data-id="element-43">
                    <MessageCircle className="w-4 h-4 text-purple-500" data-id="element-44" />
                    Viber
                  </a>
                </div>
              </div>
            </div>

            <div className="space-y-8" data-id="element-45">
              <div data-id="element-46">
                <h4 className="text-xs font-bold uppercase tracking-widest text-slate-400 mb-4" data-id="element-47">
                  Локація
                </h4>
                <p className="text-slate-600 font-medium text-sm leading-relaxed" data-id="element-48">
                  м. Рівне
                  <br data-id="element-49" />
                  <span className="text-slate-400" data-id="element-50">
                    Працюємо по всій Україні
                  </span>
                </p>
              </div>

              <div data-id="element-51">
                <h4 className="text-xs font-bold uppercase tracking-widest text-slate-400 mb-4" data-id="element-52">
                  Графік роботи
                </h4>
                <p className="text-slate-600 font-medium text-sm leading-relaxed" data-id="element-53">
                  Пн - Пт: 09:00 - 19:00
                  <br data-id="element-54" />
                  Сб - Нд: За домовленістю
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-100 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-semibold text-slate-400 uppercase tracking-widest" data-id="element-55">
          <p data-id="element-56">© {new Date().getFullYear()} Військовий Адвокат.</p>
          <div className="flex gap-6" data-id="element-57">
            <span className="hover:text-slate-900 transition-colors cursor-pointer" data-id="element-58">
              Політика конфіденційності
            </span>
          </div>
        </div>
      </div>
    </footer>;
}